import axios from 'axios'
import {
  Module,
  Mutation,
  MutationAction,
  VuexModule
} from 'vuex-module-decorators'

import store from '@/store'
import { Order } from '@/store/modules/types/order'

export const PAPER_CULTURE_ORIGIN = 'https://www.paperculture.com'

const name = 'paperCulture'
if (module.hot && store.hasModule(name)) {
  store.unregisterModule(name)
}

@Module({ name, namespaced: true, dynamic: true, store })
export default class PaperCulture extends VuexModule {
  orders: Order[] = []

  @Mutation
  clearOrders(): void {
    this.orders = []
  }

  @Mutation
  setOrders(orders: Order[]): void {
    this.orders = orders
  }

  @MutationAction({ mutate: ['orders'], rawError: true })
  async fetchOrders(args: {
    clientId: number
    authToken: string
  }): Promise<{ orders: Order[] }> {
    const { clientId, authToken } = args
    const response = await axios.get<Order[]>(
      `${PAPER_CULTURE_ORIGIN}/api/v2/accounts/${clientId}/orders`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    )
    return {
      orders: response.data
    }
  }
}
